import { Box, IconLinkedIn, IconYouTube, IconX } from '@zillow/constellation';
import React from 'react';

import type { SocialLinksProps } from './AuthorPage.types';

/**
 * Displays social media links for the author.
 */
const SOCIAL_CONFIG = [
    {
        key: 'linkedin',
        Icon: IconLinkedIn,
        label: 'LinkedIn profile',
    },
    {
        key: 'x',
        Icon: IconX,
        label: 'X (Twitter) profile',
    },
    {
        key: 'youtube',
        Icon: IconYouTube,
        label: 'YouTube channel',
    },
];

const SocialLinks: React.FC<SocialLinksProps> = ({ socialLinks }) => {
    if (!socialLinks) return null;
    return (
        <Box
            as="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '$spacing.xs',
            }}
        >
            {SOCIAL_CONFIG.map(({ key, Icon, label }) => {
                const href = socialLinks[key as keyof typeof socialLinks];
                if (!href) return null;
                return (
                    <Box
                        as="a"
                        key={key}
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                        href={href}
                        target="_blank"
                        rel="noopener nofollow"
                        aria-label={label}
                    >
                        <Icon fontColor="textWhite" />
                    </Box>
                );
            })}
        </Box>
    );
};

export default SocialLinks;
